import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as Actions from 'actions';

class ClientsColumns extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(field) {
    this.props.toggleClientColumn(field.name);
  }
  render() {
    const {fields, selected_columns} = this.props;
    const impact_columns = [
      {
        _id : 'last-impact-column-id',
        name : 'last_impact_report.map_properties.storm_date',
        label : 'Last Impact'
      },
      {
        _id : 'last-impact-details-column-id',
        name : 'last_impact_report.feature_properties',
        label : 'Last Impact Details' 
      }
    ];
    const columns = [...fields, ...impact_columns];

    return (
      <div className='row'>
        {columns.map(field => {
          return (
            <div
              className='col-md-4 col-xs-4'
              key={field._id}
              >
              <div className='checkbox-custom checkbox-default'>
                <input
                  id={field._id}
                  type='checkbox'
                  onChange={e => this.handleChange(field)}
                  checked={selected_columns.find(column => column == field.name) != null ? true : false}
                  className='clients-options-checkbox'
                />
                <label onClick={e => this.handleChange(field)}>{field.label}</label>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

const mapStateToProps = ({clients, fields}) => ({ selected_columns : clients.selected_columns, fields : fields.Client || [] });

export default connect(mapStateToProps, Actions)(ClientsColumns);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-columns.js